export default __webpack_public_path__ + "static/media/icon_cross.f504d737.svg";